import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

/**
 * Interface fuer Komponenten die ihre eigene Deaktivierung kontrollieren.
 */
export interface ComponentCanDeactivate {
    canDeactivate: () => boolean | Observable<boolean>;
}

/**
 * Funktionaler Guard: Verhindert Navigation bei ausstehenden Downloads.
 */
export const pendingDownloadGuard: CanDeactivateFn<ComponentCanDeactivate> = (component) => {
    const translate = inject(TranslateService);
    return component.canDeactivate() ? true : confirm(translate.instant('pendingDownload'));
};